import { render, staticRenderFns } from "./RoomSockets.vue?vue&type=template&id=c9425064&scoped=true"
import script from "./RoomSockets.vue?vue&type=script&lang=js"
export * from "./RoomSockets.vue?vue&type=script&lang=js"
import style0 from "./RoomSockets.vue?vue&type=style&index=0&id=c9425064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9425064",
  null
  
)

export default component.exports